$(function () {
    //Right to Left Open Menu
    if($('.navToggle').length > 0){
        $('.navToggle').on('click', function () {
            $('.nav-wrap').toggleClass('open-nav');            
            $('html').toggleClass('hidescroll');
        });
    };    
});


$(function () {
    //Right to Left Open Menu
    if($('.filterToggle').length > 0){
        $('.filterToggle').on('click', function () {
            $('.product-filter').toggleClass('open-filter');            
            $('html').toggleClass('hidescroll');
        });
    };    
});

$(function () {
    $('.menu-link').on('click', function(event) {
        event.preventDefault();
        var $menuItem = $(this).parent('.menu-item');
        var $dropdown = $(this).next('.menu-info');

        // Close all open dropdowns except the one being clicked
        $('.menu-info').not($dropdown).slideUp();
        $('.menu-item').not($menuItem).removeClass('active');

        // Toggle the dropdown menu and add/remove active class
        if ($dropdown.is(':visible')) {
            $dropdown.slideUp();
            $menuItem.removeClass('active');
        } else {
            $dropdown.slideDown();
            $menuItem.addClass('active');
        }
    });

    // Close the dropdown if clicking outside of it
    $(document).on('click', function(event) {
        if (!$(event.target).closest('.menu-item').length) {
            $('.menu-info').slideUp();
            $('.menu-item').removeClass('active');
        }
    });
});

